import { render, staticRenderFns } from "./clinic.vue?vue&type=template&id=2e33e11a&scoped=true"
import script from "./clinic.vue?vue&type=script&lang=js"
export * from "./clinic.vue?vue&type=script&lang=js"
import style0 from "./clinic.vue?vue&type=style&index=0&id=2e33e11a&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e33e11a",
  null
  
)

export default component.exports